import { render, staticRenderFns } from "./OwnerProfile.vue?vue&type=template&id=ccce6b02&"
import script from "./OwnerProfile.vue?vue&type=script&lang=ts&"
export * from "./OwnerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports